import { jwtDecode } from "jwt-decode";
import { tokenHelper } from "./tokenHelper";

export interface TokenPayload {
  sub: number;
  name: string;
  nombre_rol: string;
  cod_entidad: number | null;
  cod_departamento: number | null;
  /** 1 = masculino, 2 = femenino, null = persona jurídica o sin dato. */
  sexo_biologico?: number | null;
  /** Solo para mostrar en el encabezado del tablero. */
  nombre_entidad?: string | null;
  nombre_departamento?: string | null;
  cargo?: string | null;
  exp?: number;
}

export function decodeToken(token: string): TokenPayload | null {
  try {
    return jwtDecode<TokenPayload>(token);
  } catch {
    return null;
  }
}

// Lee el token de sessionStorage y lo decodifica. Devuelve null si no hay
// token o si está corrupto.
export function useUsuarioToken(): TokenPayload | null {
  const token = tokenHelper.get();
  if (!token) return null;
  return decodeToken(token);
}
